import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2bdf5e6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "header-menu align-items-stretch",
  id: "kt_header_menu",
  "data-kt-drawer": "true",
  "data-kt-drawer-name": "header-menu",
  "data-kt-drawer-activate": "{default: true, lg: false}",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-width": "{default:'200px', '300px': '250px'}",
  "data-kt-drawer-direction": "start",
  "data-kt-drawer-toggle": "#kt_header_menu_mobile_toggle",
  "data-kt-swapper": "true",
  "data-kt-swapper-mode": "prepend",
  "data-kt-swapper-parent": "{default: '#kt_body', lg: '#kt_header_nav'}"
}
const _hoisted_2 = { class: "d-block d-lg-none" }
const _hoisted_3 = { class: "menu-item" }
const _hoisted_4 = { class: "menu-content d-flex align-items-center flex-wrap" }
const _hoisted_5 = { class: "d-flex flex-column" }
const _hoisted_6 = { class: "fw-bold d-flex align-items-center" }
const _hoisted_7 = {
  href: "#",
  class: "fw-semobold text-muted text-hover-primary"
}
const _hoisted_8 = {
  key: 0,
  class: "menu-item me-lg-1"
}
const _hoisted_9 = { class: "menu-title" }
const _hoisted_10 = {
  key: 1,
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-start",
  class: "menu-item menu-lg-down-accordion me-lg-1"
}
const _hoisted_11 = { class: "menu-title" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow d-lg-none" }, null, -1))
const _hoisted_13 = { class: "menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-rounded-0 py-lg-4 w-lg-225px" }
const _hoisted_14 = {
  key: 0,
  "data-kt-menu-trigger": "{default:'click', lg: 'hover'}",
  "data-kt-menu-placement": "right-start",
  class: "menu-item menu-lg-down-accordion"
}
const _hoisted_15 = { class: "menu-icon" }
const _hoisted_16 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_17 = { class: "menu-title" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1))
const _hoisted_19 = { class: "menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px" }
const _hoisted_20 = {
  key: 0,
  "data-kt-menu-trigger": "{default:'click', lg: 'hover'}",
  "data-kt-menu-placement": "right-start",
  class: "menu-item menu-lg-down-accordion"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1))
const _hoisted_22 = { class: "menu-title" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-arrow" }, null, -1))
const _hoisted_24 = { class: "menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1))
const _hoisted_26 = { class: "menu-title" }
const _hoisted_27 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "menu-bullet" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bullet bullet-dot" })
], -1))
const _hoisted_29 = { class: "menu-title" }
const _hoisted_30 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_31 = { class: "menu-icon" }
const _hoisted_32 = {
  key: 1,
  class: "svg-icon svg-icon-2"
}
const _hoisted_33 = { class: "menu-title" }
const _hoisted_34 = {
  key: 0,
  class: "menu-item me-lg-1"
}
const _hoisted_35 = {
  key: 1,
  class: "menu-item me-lg-1"
}
const _hoisted_36 = {
  key: 2,
  class: "menu-item me-lg-1"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "separator my-5",
  style: {"border-bottom":"1px solid #e4e6ef !important"}
}, null, -1))
const _hoisted_38 = { class: "d-block d-lg-none" }
const _hoisted_39 = {
  class: "menu-item",
  "data-kt-menu-trigger": "hover",
  "data-kt-menu-placement": "right-start",
  "data-kt-menu-flip": "center, top"
}
const _hoisted_40 = { class: "menu-link" }
const _hoisted_41 = { class: "menu-title" }
const _hoisted_42 = { class: "rounded" }
const _hoisted_43 = ["src"]
const _hoisted_44 = { class: "menu-sub menu-sub-dropdown w-225px py-4" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { class: "symbol symbol-20px me-4" }
const _hoisted_47 = ["src"]
const _hoisted_48 = { class: "menu-item my-1" }
const _hoisted_49 = { class: "menu-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserAvatar = _resolveComponent("UserAvatar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["menu menu-rounded menu-column menu-lg-row menu-active-bg menu-title-gray-700 menu-state-primary menu-arrow-gray-400 fw-semibold my-5 my-lg-0 align-items-stretch px-2 px-lg-0 mh-100vh", {}]),
      id: "#kt_header_menu",
      "data-kt-menu": "true"
    }, [
      _createElementVNode("template", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_UserAvatar, {
              avatar: _ctx.user.avatar,
              name: _ctx.user.name,
              side: "client",
              size: "50px",
              rounded: ""
            }, null, 8, ["avatar", "name"]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.user.name), 1),
              _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.user.email), 1)
            ])
          ])
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MainMenuConfig, (item, i) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
          (!item.heading)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(item.pages, (menuItem, j) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
                  (
                menuItem.heading &&
                _ctx.$cans(menuItem.permissions) &&
                _ctx.checkTenantPermission(menuItem)
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(_component_router_link, {
                          class: "menu-link",
                          to: menuItem.route,
                          "active-class": "active"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.translate(menuItem.heading)), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            : _createCommentVNode("", true),
          (item.heading && _ctx.$cans(item.permissions))
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("span", {
                  class: _normalizeClass(["menu-link py-3", { active: _ctx.hasActiveChildren(item.route) }])
                }, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.translate(item.heading)), 1),
                  _hoisted_12
                ], 2),
                _createElementVNode("div", _hoisted_13, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.pages, (menuItem, j) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: j }, [
                      (menuItem.sectionTitle)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["menu-link py-3", { active: _ctx.hasActiveChildren(menuItem.route) }])
                            }, [
                              _createElementVNode("span", _hoisted_15, [
                                (_ctx.headerMenuIcons === 'font')
                                  ? (_openBlock(), _createElementBlock("i", {
                                      key: 0,
                                      class: _normalizeClass([menuItem.fontIcon, "bi fs-3"])
                                    }, null, 2))
                                  : _createCommentVNode("", true),
                                (_ctx.headerMenuIcons === 'svg')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                      _createVNode(_component_inline_svg, {
                                        src: menuItem.svgIcon
                                      }, null, 8, ["src"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.translate(menuItem.sectionTitle)), 1),
                              _hoisted_18
                            ], 2),
                            _createElementVNode("div", _hoisted_19, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem.sub, (menuItem1, k) => {
                                return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                                  (menuItem1.sectionTitle)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass(["menu-link py-3", { active: _ctx.hasActiveChildren(menuItem1.route) }])
                                        }, [
                                          _hoisted_21,
                                          _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.translate(menuItem1.sectionTitle)), 1),
                                          _hoisted_23
                                        ], 2),
                                        _createElementVNode("div", _hoisted_24, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItem1.sub, (menuItem2, l) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: l,
                                              class: "menu-item"
                                            }, [
                                              _createVNode(_component_router_link, {
                                                class: "menu-link py-3",
                                                "active-class": "active",
                                                to: menuItem2.route
                                              }, {
                                                default: _withCtx(() => [
                                                  _hoisted_25,
                                                  _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.translate(menuItem2.heading)), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["to"])
                                            ]))
                                          }), 128))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (menuItem1.heading)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                        _createVNode(_component_router_link, {
                                          class: "menu-link",
                                          "active-class": "active",
                                          to: menuItem1.route
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_28,
                                            _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.translate(menuItem1.heading)), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["to"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (menuItem.heading && _ctx.$cans(menuItem.permissions))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            _createVNode(_component_router_link, {
                              class: "menu-link",
                              "active-class": "active",
                              to: menuItem.route
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_31, [
                                  (_ctx.headerMenuIcons === 'font')
                                    ? (_openBlock(), _createElementBlock("i", {
                                        key: 0,
                                        class: _normalizeClass([menuItem.fontIcon, "bi fs-3"])
                                      }, null, 2))
                                    : _createCommentVNode("", true),
                                  (_ctx.headerMenuIcons === 'svg')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                                        _createVNode(_component_inline_svg, {
                                          src: menuItem.svgIcon
                                        }, null, 8, ["src"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.translate(menuItem.heading)), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128)),
      (_ctx.isMobile && _ctx.$cans(['Sales']))
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
            _createVNode(_component_router_link, {
              class: "menu-link",
              to: "/sales",
              "active-class": "active"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("title.salesCenter")), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.isMobile && _ctx.$cans(['Rep']))
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
            _createVNode(_component_router_link, {
              class: "menu-link",
              to: "/rep",
              "active-class": "active"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("title.repCenter")), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.isMobile && _ctx.$cans(['IB']) && _ctx.ibEnabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
            _createVNode(_component_router_link, {
              class: "menu-link",
              to: "/ib",
              "active-class": "active"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("title.ibCenter")), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      _hoisted_37,
      _createElementVNode("template", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("span", _hoisted_41, [
              _createElementVNode("span", _hoisted_42, [
                _createElementVNode("img", {
                  class: "w-15px h-15px rounded-1 me-2",
                  src: _ctx.currentLanguageLocale.flag,
                  alt: "BCR Pro"
                }, null, 8, _hoisted_43),
                _createElementVNode("span", null, _toDisplayString(_ctx.currentLanguageLocale.name), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (lang, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "menu-item px-3",
                key: index
              }, [
                _createElementVNode("a", {
                  onClick: ($event: any) => (_ctx.setLang(lang.code)),
                  href: "#",
                  class: _normalizeClass(["menu-link d-flex px-5", { active: _ctx.currentLanguage(lang.code) }])
                }, [
                  _createElementVNode("span", _hoisted_46, [
                    _createElementVNode("img", {
                      class: "rounded-1",
                      src: lang.flag,
                      alt: "BCR Pro"
                    }, null, 8, _hoisted_47)
                  ]),
                  _createTextVNode(" " + _toDisplayString(lang.name ?? "Name"), 1)
                ], 10, _hoisted_45)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createVNode(_component_router_link, {
            to: "/profile",
            class: "menu-link",
            "active-class": "active"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                class: _normalizeClass(["svg-icon svg-icon-4 me-1", {}])
              }, [
                _createVNode(_component_inline_svg, { src: "/images/icons/general/setting.svg" })
              ]),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("title.accountSettings")), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.signOut())),
            class: "menu-link"
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["svg-icon svg-icon-4 me-1", {}])
            }, [
              _createVNode(_component_inline_svg, { src: "/images/icons/general/exit.svg" })
            ]),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("action.signOut")), 1)
          ])
        ])
      ])
    ])
  ]))
}